export const counsellorConstants = {
  GET_COUNSELLOR_STATUS_REQUEST: "GET_COUNSELLOR_STATUS_REQUEST",
  GET_COUNSELLOR_STATUS_SUCCESS: "GET_COUNSELLOR_STATUS_SUCCESS",
  GET_COUNSELLOR_STATUS_FAILURE: "GET_COUNSELLOR_STATUS_FAILURE",

  GET_COUNSELLOR_DETAILS_REQUEST: "GET_COUNSELLOR_DETAILS_REQUEST",
  GET_COUNSELLOR_DETAILS_SUCCESS: "GET_COUNSELLOR_DETAILS_SUCCESS",
  GET_COUNSELLOR_DETAILS_FAILURE: "GET_COUNSELLOR_DETAILS_FAILURE",

  GET_COUNSELLOR_PROFILE_REQUEST: "GET_COUNSELLOR_PROFILE_REQUEST",
  GET_COUNSELLOR_PROFILE_SUCCESS: "GET_COUNSELLOR_PROFILE_SUCCESS",
  GET_COUNSELLOR_PROFILE_FAILURE: "GET_COUNSELLOR_PROFILE_FAILURE",

  GET_MULTI_COUNSELLOR_REQUEST: "GET_MULTI_COUNSELLOR_REQUEST",
  GET_MULTI_COUNSELLOR_SUCCESS: "GET_MULTI_COUNSELLOR_SUCCESS",
  GET_MULTI_COUNSELLOR_FAILURE: "GET_MULTI_COUNSELLOR_FAILURE",
};



// WEBPACK FOOTER //
// ./src/store/constants/counsellor.constants.js